import initWordPress from './initWordPress';
import checkIfWordPress from './checkIfWordPress';
import getLeadinConfig from './getLeadinConfig';
import buildWordpressUrl from './buildWordpressUrl';
const isWordPress = checkIfWordPress();

const isWordPressAdmin = () => getLeadinConfig().admin;

export { initWordPress, isWordPress, isWordPressAdmin, buildWordpressUrl };